import { createStyles } from "@mantine/core"

export const useStyles = createStyles(
    (
        theme,
        { isOpen, loggedInAsUser, popdownIsOpen }: { isOpen: boolean; loggedInAsUser: boolean; popdownIsOpen: boolean },
    ) => ({
        target: {
            padding: ".5rem .625rem .5rem .75rem",
            display: "inline-flex",
            alignItems: "center",
            gap: ".5rem",
            color: "white",
            height: "2.5rem",
            backgroundColor: isOpen ? theme.colors.violet[8] : theme.colors.violet[7],
            border: 0,
            borderRadius: ".25rem",
            maxWidth: "15rem",

            "&:hover": {
                backgroundColor: theme.colors.violet[9],
            },

            ...(loggedInAsUser && {
                color: theme.colors.violet[9],
                backgroundColor: theme.colors.violet[2],

                "&:hover": {
                    backgroundColor: theme.colors.violet[3],
                },
            }),

            ...(popdownIsOpen && {
                color: theme.colors.gray[9],
                backgroundColor: "white",

                "&:hover": {
                    backgroundColor: theme.colors.violet[1],
                },
            }),

            ".region-button--globe-icon": {
                width: ".875rem",
            },

            ".region-button--name": {
                fontSize: ".875rem",
                fontWeight: 500,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                maxWidth: "100%",
            },

            ".region-button--angle-icon": {
                width: ".625rem",
                fontSize: "1.125rem",
            },
        },
    }),
)
